import { Link } from "react-router-dom";

const QRCodeCard = () => (
  <div className="bg-white p-6 rounded-xl text-center shadow-xl max-w-sm mx-auto mt-10">
    <div className="bg-primary text-white rounded-t-xl py-4 relative">
      <p className="text-lg font-bold">Customer QR Code</p>
    </div>
    <img src="/images/qr.png" alt="QR Code" className="mx-auto my-4 w-32 h-32" />
    <div className="bg-white p-4 rounded-b-xl">
      <h2 className="font-bold text-lg">Share Your QR Code Link</h2>
      <p className="text-gray-500 mt-2">https://stellaris.qrcode.shop</p>
      <div className="flex justify-center gap-4 mt-4">
        <button className="border border-primary text-primary px-4 py-1 rounded-full">Copy link</button>
        <Link to="/productlist" className="bg-primary text-white px-4 py-1 rounded-full">Share</Link>
      </div>
    </div>
  </div>
);

export default QRCodeCard;